import { Component, Input, OnInit } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';
import { marcHolding, marc } from 'src/app/models/walai';
@Component({
  selector: 'app-holding',
  templateUrl: './holding.component.html',
  styleUrls: ['./holding.component.css']
})
export class HoldingComponent implements OnInit {
  @Input() bibid: string;
  holdings: any[];
  constructor(private homeService: HomeService) { }

  ngOnInit(): void {
    this.homeService.getHolding(this.bibid).subscribe((holdings: marcHolding[]) => {
      //ตัวแปรเก็บ Item ทั้งหมด
      this.holdings = holdings;
    });
  }

  copyToClipboard(): void {
    if (!this.holdings || this.holdings.length === 0) {
      return;
    }

    // Format Holding data as text
    let holdingText = 'Holding Information\n';
    holdingText += '='.repeat(80) + '\n\n';

    this.holdings.forEach((holding, holdingIndex) => {
      holdingText += `Location: ${holding.Location}\n`;
      holdingText += '-'.repeat(80) + '\n';

      holding.HoldingData.forEach((data: any, index: number) => {
        holdingText += `${index + 1}. ${data.Subfield}\n`;
      });

      holdingText += '\n';
    });

    // Copy to clipboard
    navigator.clipboard.writeText(holdingText).then(() => {
      alert('Holding information copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }
}
